<div id="login" fusePerfectScrollbar class="fx-column">
  <div id="login-form-wrapper" class="fx-column fx-justify-center fx-items-center">
    <div class="form-wrapper">

      <div class="logo mb-32">
        <img src="assets/images/logos/tangerine_logo.png" />
      </div>

      <div
        id="login-form"
        [hidden]="navigating"
        *fuseIfOnDom
				[@animate]="{
					value: '*',
					params: { duration: '300ms', y: '100px' }
				}"
        >
        @if (logging) {
          <mat-progress-bar
            class="mt-24 mb-24"
            style="min-width:300px"
            mode="indeterminate"
          ></mat-progress-bar>
        }

        <form name="loginForm" [formGroup]="loginForm" novalidate>
          <mat-form-field appearance="fill">
            <mat-label>Username</mat-label>
            <input
              matInput
              placeholder="Codice Utente"
              formControlName="access_username"
              autocomplete="access_username"
              />
            <mat-icon matSuffix class="secondary-text">person_outline</mat-icon>
            @if (
              loginFormErrors && loginFormErrors.access_username
              ) {
              @if (loginFormErrors.access_username.required) {
                <mat-error
                  >
                  {{ 'LOGIN.ERROR.CODE_REQUIRED' | translate }}
                </mat-error>
              }
              @if (
                !loginFormErrors.access_username.required &&
                loginFormErrors.access_username.invalid
                ) {
                <mat-error
                  >
                  {{ 'LOGIN.ERROR.INVALID_CODE' | translate }}
                </mat-error>
              }
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <input
              matInput
              type="password"
              placeholder="Password"
              formControlName="password"
              autocomplete="current-password"
              />
            <mat-icon matSuffix class="secondary-text"
              >vpn_key</mat-icon
              >
              @if (loginFormErrors && loginFormErrors.password) {
                @if (loginFormErrors.password.required) {
                  <mat-error
                    >
                    {{ 'LOGIN.ERROR.PASSWORD_REQUIRED' | translate }}
                  </mat-error>
                }
              }
            </mat-form-field>

            <div class="remember-forgot-password fx-row fx-justify-space-between fx-items-center">
              <mat-checkbox
                class="remember-me"
                aria-label="Remember Me"
                formControlName="rememberMe"
                >
                <span>{{ 'LOGIN.REMEMBER_ME' | translate }}</span>
              </mat-checkbox>

            </div>

            @if (lastLoginErrorMessage) {
              <p class="red-fg">
                {{ lastLoginErrorMessage }}
              </p>
            }

            <button
              mat-flat-button
              (click)="onLoginClick()"
              color="accent"
              class="submit-button"
              aria-label="LOG IN"
              [disabled]="loginForm.invalid || logging"
              >
              <span>Accedi</span>
              <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
            </button>
          </form>

          <!-- pipe, non direttiva `translate=`: quest'ultima scrive nel contenuto
          dell'elemento e con Ivy finiva per concatenare la traduzione due volte -->
          <a
            class="forgot-password"
            [routerLink]="'/auth/forgot-password'"
            >
            {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
          </a>

          @if (false) {
            <div class="register fx-column fx-justify-center fx-items-center">
              <span class="text">Don't have an account?</span>
              <a class="link" [routerLink]="'/auth/register'"
                >Create an account</a
                >
              </div>
            }
          </div>
        </div>
      </div>
    </div>
